const {$} = window;

export default function animateCSS(element, animationName, callback) {
  const node = $(element), animname = animationName.split(/\s+/);

  $(node).addClass("animated"); $(node).addClass(animname);

  function handleAnimationEnd() {
    $(node).removeClass("animated"); $(node).removeClass(animname);
    $(node).on("animationend", handleAnimationEnd);
    if (typeof callback === "function") callback();
  }

  $(node).off("animationend", handleAnimationEnd);
}

/* you can use next animation:
    rz-animate-bounce, rz-animate-flash, rz-animate-pulse, rz-animate-rubberBand
    shake headShake swing tada
    wobble jello bounceIn bounceInDown
    bounceInLeft bounceInRight bounceInUp bounceOut
    bounceOutDown bounceOutLeft bounceOutRight bounceOutUp
    fadeIn fadeInDown fadeInDownBig fadeInLeft
    fadeInLeftBig fadeInRight fadeInRightBig fadeInUp
    fadeInUpBig fadeOut fadeOutDown fadeOutDownBig
    fadeOutLeft fadeOutLeftBig fadeOutRight fadeOutRightBig
    fadeOutUp fadeOutUpBig flipInX flipInY
    flipOutX flipOutY lightSpeedIn lightSpeedOut
    rotateIn rotateInDownLeft rotateInDownRight rotateInUpLeft
    rotateInUpRight rotateOut rotateOutDownLeft rotateOutDownRight
    rotateOutUpLeft rotateOutUpRight hinge jackInTheBox
    rollIn rollOut zoomIn zoomInDown
    zoomInLeft zoomInRight zoomInUp zoomOut
    zoomOutDown zoomOutLeft zoomOutRight zoomOutUp
    slideInDown slideInLeft slideInRight slideInUp
    slideOutDown slideOutLeft slideOutRight slideOutUp
    heartBeat

    see demo here: https://daneden.github.io/animate.css/
  */

// Animate.js Start
$("[class^='rz-animate-']").each((el, elem) => {
  const allclases = $(elem).attr("class").split(/\s+/);
  $.each(allclases, (c, clstxt) => {
    if (~clstxt.indexOf("rz-animate-")) {
      const allparams = clstxt.split("-");
      let animationtype = allparams[2] || "";
      if (allparams.length > 3) animationtype += " delay-" + allparams[3];
      animateCSS(elem, animationtype);
    }
  });
});
